<template>
    <div class="background">
        <!-- Background image for desktop -->
        <el-image v-if="desktop && backgrounds.desktop[desktop]"
                :src="backgrounds.desktop[desktop]"
                :class="`hidden-md-and-down background-image background-desktop-image background-${desktop}-image`"
                v-show="loadedBackgrounds.desktop[desktop]"
                @load="onImgLoad('desktop', desktop)"
        ></el-image>

        <!-- Background image for tablet -->
        <el-image v-if="tablet && backgrounds.tablet[tablet]"
                  :src="backgrounds.tablet[tablet]"
                  :class="`hidden-sm-and-down hidden-lg-and-up background-image background-tablet-image background-${tablet}-image`"
                  v-show="loadedBackgrounds.tablet[tablet]"
                  @load="onImgLoad('tablet', tablet)"
        ></el-image>

        <!-- Background image for mobile -->
        <el-image v-if="mobile && backgrounds.mobile[mobile]"
                  :src="backgrounds.mobile[mobile]"
                  :class="`hidden-md-and-up background-image background-mobile-image background-${mobile}-image`"
                  v-show="loadedBackgrounds.mobile[mobile]"
                  @load="onImgLoad('mobile', mobile)"
        ></el-image>
    </div>
</template>

<script>
export default {
  name: 'Background',
  components: {},
  props: {
    desktop: {
      default: 'default'
    },
    tablet: {
      default: 'default'
    },
    mobile: {
      default: 'default'
    }
  },
  mounted () {},
  data () {
    return {
      backgrounds: {
        /* Backgrounds for desktop */
        desktop: {
          default: require('@/assets/background-desktop-default.png'),
          party: require('@/assets/background-desktop-party.png'),
          mascot: require('@/assets/background-desktop-mascot.png'),
          'system-details': require('@/assets/background-desktop-system-details.png'),
          'system-tile': require('@/assets/background-system-tile.png')
        },

        /* Backgrounds for tablet */
        tablet: {
          default: require('@/assets/background-tablet-default.png'),
          'system-details': require('@/assets/background-tablet-system-details.png'),
          'system-tile': require('@/assets/background-system-tile.png')
        },

        /* Backgrounds for mobile */
        mobile: {
          default: require('@/assets/background-mobile-default.png'),
          'system-details': require('@/assets/background-mobile-system-details.png'),
          'system-tile': require('@/assets/background-system-tile.png')
        }
      },

      loadedBackgrounds: {
        /* Backgrounds for desktop */
        desktop: {
          default: false,
          party: false,
          mascot: false,
          'system-details': false,
          'system-tile': false
        },

        /* Backgrounds for tablet */
        tablet: {
          default: false,
          'system-details': false,
          'system-tile': false
        },

        /* Backgrounds for mobile */
        mobile: {
          default: false,
          'system-details': false,
          'system-tile': false
        }
      }
    }
  },

  methods: {
    onImgLoad (size, name) {
      if (!this.loadedBackgrounds[size]) return
      if (!(name in this.loadedBackgrounds[size])) return
      this.loadedBackgrounds[size][name] = true
    }
  }
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.background {
    .background-image {
        position: absolute;
        z-index:-100;
    }

    .background-desktop-image {
        position: fixed;
        width: 1543px;
        height: 818px;
        margin-top: -10em;
        margin-left: -53em;
        opacity: 0.5;
    }

    .background-tablet-image {
        position: fixed;
        width: 1024px;
        height: 768px;
        margin-top: -10em;
        margin-left: -30em;
        opacity: 0.5;
    }

    .background-mobile-image {
        position: fixed;
        width: 414px;
        height: 736px;
        margin-top: -13em;
        margin-left: -12em;
        opacity: 0.5;
    }

    .background-mascot-image {
        position: fixed;
        width: 600px;
        height: 779px;
        margin-top: -5em;
        margin-left: 5em;
    }

    .background-system-tile-image {
        position: relative;
        z-index: -1;
        margin-top: -400px;
        width: 100%;
        height: auto;
        margin-left: 0em;
        opacity: 1;
    }

    .background-system-tile-image {
        position: relative;
        z-index: -1;
        margin-top: -400px;
        width: 100%;
        height: auto;
        margin-left: 0em;
        opacity: 1;
    }

    .background-system-details-image {
        margin-left: -7em;
        margin-right: 0px;
        margin-top: -2em;
        position: relative;
        z-index: 1;
        width: 150%;
        max-width: 900px;
        height: auto;
        opacity: 1;
    }
    .background-system-details-image.background-mobile-image {
        margin-left: -6em;
        margin-top: -1em;
    }
    .background-system-details-image.background-tablet-image {
        margin-left: -6em;
        margin-top: -1em;
    }

    @media screen and (max-width: 28em) {
        .background-system-details-image.background-mobile-image {
            margin-left: -2em;
            margin-top: -1em;
        }
    }
}
</style>
